<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-tabs background-color="white" color="deep-purple accent-4" left>
          <v-tab>Dashboard</v-tab>
          <v-tab>Reporting</v-tab>
          <v-tab-item>
            <v-container fluid>
              <v-row no-gutters>
                Dashboard
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid>
              <v-row no-gutters>
                <reports />
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Reports from "@/components/Reports";
export default {
  components: {
    Reports
  }
};
</script>
